module.exports = __webpack_public_path__ + "media/images/Divorcee-Matrimony-in-UK-5e84812b34834aa5d08028fd9b93a5dc.jpg";